import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PAGE_SIZE_OPTIONS, type PageSize } from '@/shared/lib/route';
import { Select, toast } from '@/shared/ui';

type PageSizeSelectorProps = {
  pageSize: number | undefined;
};

/**
 * ページサイズ選択コンポーネント
 */
export const PageSizeSelector = ({ pageSize }: PageSizeSelectorProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <Select
        triggerClassName="min-w-[60px]"
        options={PAGE_SIZE_OPTIONS.map((size) => ({
          label: t('common.table.pagination.page-size-label', { size }),
          value: size,
        }))}
        value={pageSize}
        onValueChange={(value) => {
          if (typeof value === 'number') {
            navigate({
              to: '.',
              search: (prev) => ({
                ...prev,
                page: 1, // ページサイズ変更時はページ番号を1にリセット
                page_size: value as PageSize,
              }),
            });
          } else {
            toast.error(t('common.table.pagination.page-size-change-error'));
          }
        }}
      />
    </div>
  );
};
